export const language: any ={
  LabelFavorites: "Yêu thích",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe: `Chưa có món ăn nào trong danh sách yêu thích.<br/>Hãy thêm món ăn mà bạn thích vào nhé!`,
  LabelDoYouWantUnSave: `Bạn có muốn bỏ lưu công thức tương ứng không ?`,
  save: 'Lưu',
  unsave: 'Lưu',
  OkFavorite: "Có",
  CloseFavorite: "Không",
}

